// TODO: Note this file will be refactored when this page is rolled out in the
// various flavors
import React from 'react'
import moment from 'moment'
import injectStyles from 'react-jss'

import StatsPage from 'Components/Page/StatsPageWrapper'
import BulletChartsForMetric from 'Components/Stats/BulletChartsForMetric'
import GLineChart from 'Components/Stats/GLineChart'
import ClientReferral from 'Components/Stats/BulletChartsForMetric/ClientReferral'
import TagTable from './components/TagTable'
import CityTable from './components/CityTable'
import WeeksTable from './components/WeeksTable'
import EvolutionPerCityChart from './components/HighchartsCharts/EvolutionPerCityChart'
import EvolutionOverTheTimeChart from './components/HighchartsCharts/EvolutionOverTheTimeChart'
import BigCardsBlock from './components/BigCardsBlock'

import { urlGet } from 'Utils/URL'
import styles from './styles'
import { formatData } from './util'
import { authorization } from '../../Module/Auth/Auth'
import CampaignTimeline from './components/CampaignTimeline'
import CampaignPerforming from './components/CampaignPerforming'

const UnstyledStatsOverview = ({ campaignResults, classes }) => {
  const {
    missions,
    metrics,
    totalFlyersDistributed,
    totalWeeks,
    cityTableData,
    tagTableData,
    weeksTableData,
    evolutionOverTheTimeChartData,
    evolutionPerCityChartData,
    chartDataHash,
    chartMetrics,
    chartWeeks,
    bulletCharts,
    conversionData,
    conversionDataAxisKeys,
    newestConversionTimestamp,
  } = formatData(campaignResults)
  const currencySign = campaignResults.country.currencySign
  const { clientReferralProgram } = campaignResults
  return (
    <StatsPage>
      <div className={classes.wrapper}>
        <div className={classes.mainContainer}>
          {authorization.isClientAdmin() ||
          authorization.isCityManager() ||
          authorization.isAdmin() ? (
            <CampaignTimeline campaignId={campaignResults.id} />
          ) : null}
          {newestConversionTimestamp && conversionData.data.length > 0 && (
            <div className={classes.newestConversionTimestamp}>
              Last Updated: at{' '}
              {newestConversionTimestamp &&
                moment(newestConversionTimestamp).format('DD-MM-YYYY HH:mm')}
            </div>
          )}
          <CampaignPerforming
            campaignId={campaignResults.id}
            campaignName={campaignResults.name}
          />
          {clientReferralProgram &&
          (authorization.isCityManager() || authorization.isAdmin()) ? (
            <ClientReferral clientReferralProgram={clientReferralProgram} />
          ) : null}
          {bulletCharts ? (
            <BulletChartsForMetric
              {...bulletCharts}
              currencySign={currencySign}
            />
          ) : null}
          <CityTable
            classes={classes}
            data={cityTableData}
            currencySign={currencySign}
          />
          <WeeksTable
            classes={classes}
            data={weeksTableData}
            currencySign={currencySign}
          />
          <TagTable
            classes={classes}
            data={tagTableData}
            currencySign={currencySign}
          />
          {urlGet('beta') ? (
            <GLineChart
              title="Average conversions per mission over time"
              //titleKey="conversion"
              axisKeys={conversionDataAxisKeys}
              data={conversionData}
            />
          ) : null}
          <EvolutionPerCityChart
            chartMetrics={chartMetrics}
            chartWeeks={chartWeeks}
            chartDataHash={chartDataHash}
            currencySign={currencySign}
            data={evolutionPerCityChartData}
          />
          <EvolutionOverTheTimeChart
            chartMetrics={chartMetrics}
            chartWeeks={chartWeeks}
            chartDataHash={chartDataHash}
            currencySign={currencySign}
            data={evolutionOverTheTimeChartData}
          />
        </div>
        <BigCardsBlock
          missions={missions}
          metrics={metrics}
          totalFlyersDistributed={totalFlyersDistributed}
          totalWeeks={totalWeeks}
          bulletCharts={bulletCharts}
          currencySign={currencySign}
        />
      </div>
    </StatsPage>
  )
}

export default injectStyles(styles)(UnstyledStatsOverview)



// WEBPACK FOOTER //
// ./src/Containers/StatsOverview/StatsOverview.js